import React from "react";
import { IconType } from "../../type/icon_type";

const ExitIcon = ({
  color = "#73787E",
  width = "24",
  height = "24",
}: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 20H6.66667C6.22464 20 5.80072 19.8244 5.48816 19.5118C5.17559 19.1993 5 18.7754 5 18.3333V6.66667C5 6.22464 5.17559 5.80072 5.48816 5.48816C5.80072 5.17559 6.22464 5 6.66667 5H10M16 16L20 12L16 8M19 12H9"
        stroke={color}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ExitIcon;
